'use client';

import { useOnlineStatus } from './useOnlineStatus';

/**
 * Global connectivity notice for the (app) group. The session loop itself
 * stays usable offline (queued answers replay on reconnect via
 * lib/training/offlineAnswerQueue.ts) — this banner is purely informational.
 */
export default function OfflineBanner() {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="app-offline-banner" role="status" aria-live="polite">
      <span className="app-offline-banner-icon" aria-hidden="true">
        !
      </span>
      You&apos;re offline — training keeps working, progress will sync when you
      reconnect.
    </div>
  );
}
